import { LanguageCode } from "src/utils/localization/languages/types";
import { INavLink } from "components/HeaderNavBar/type";

type AllSubscribeToNewsletterUrls = Record<
  LanguageCode,
  SubscribeToNewsletterUrls
>;

type SubscribeToNewsletterUrls = {
  privacyPolicyUrl: INavLink;
};

const subscribeToNewsletterUrls: AllSubscribeToNewsletterUrls = {
  en: {
    privacyPolicyUrl: {
      href: "/privacy-policy.html",
      title: "Privacy Policy",
      newTab: true
    }
  },
  de: {
    privacyPolicyUrl: {
      href: "/de/datenschutzrichtlinien.html",
      title: "Datenschutzrichtlinien",
      newTab: true
    }
  },
  fr: {
    privacyPolicyUrl: {
      href: "/fr/politique-de-confidentialite.html",
      title: "Politique de confidentialité",
      newTab: true
    }
  },
  es: {
    privacyPolicyUrl: {
      href: "/es/politica-privacidad.html",
      title: "Política de privacidad",
      newTab: true
    }
  },
  "pt-br": {
    privacyPolicyUrl: {
      href: "/pt-br/politica-de-privacidade.html",
      title: "Política De Privacidade",
      newTab: true
    }
  }
};

export const getPrivacyPolicyUrl = (languageCode: LanguageCode) =>
  subscribeToNewsletterUrls[languageCode].privacyPolicyUrl;
